import * as React from "react";
import Spinner from "../utilities/Spinner";
import FormComponent from "./Form";

const Navbar = React.lazy(() => import("./Navbar"));
const Hero = React.lazy(() => import("./Hero"));
const Banner = React.lazy(() => import("./Banner"));
const Banner2 = React.lazy(() => import("./Banner2"));
const Banner3 = React.lazy(() => import("./Banner3"));
const Kreator = React.lazy(() => import("./Kreator"));
const Form = React.lazy(() => import("./Form"));
const Przyklady = React.lazy(() => import("./Przyklady"));
const Oferta = React.lazy(() => import("./Oferta"));
const Footer = React.lazy(() => import("./Footer"));
const SuccessPage = React.lazy(() => import("./SuccessPage"));
const Vvideo = React.lazy(() => import("./Vvideo"));
const DoYouKnow = React.lazy(() => import("./Doyouknow"));
const FAQ = React.lazy(() => import("./FAQ"));
const CeatorButtons = React.lazy(() => import("./CreatorButtons"));

const Home = () => {
  return (
    <React.Suspense fallback={<Spinner />}>
      <Navbar />
      <Hero />

      <Przyklady />
      <div style={{ marginTop: "5px" }}></div>
      <CeatorButtons />
      <Kreator />
      <Vvideo />
      <Form />
      <FAQ />
      <DoYouKnow />
      <Banner3 />
      <Oferta />
      <Footer />
    </React.Suspense>
  );
};

export default Home;
